import { VoiceboxMessage } from 'src/utils/voicebox/types';

export enum VoiceboxMode {
  EXISTING = 'EXISTING',
  NEW = 'NEW',
}

export type VoiceboxState = {
  mode: VoiceboxMode | null;
  conversationId: string;
  conversationMessages: VoiceboxMessage[];
  pending: boolean;
  projectId: string;
  openAiKey: string;
};

export const createInitialVoiceboxState = (): VoiceboxState => ({
  mode: null,
  conversationId: '',
  conversationMessages: [],
  pending: false,
  projectId: '',
  openAiKey: '',
});
